import { Router, UrlTree } from '@angular/router';
import { AppConfig } from '@mkp/shared/util-app-config';

export const getLoadedResult = (router: Router, hasSelectedAccount: boolean, isBoUser: boolean) => {
  return hasSelectedAccount || getUrlTree(router, isBoUser);
};

export const getUrlTree = (router: Router, isBoUser: boolean): UrlTree =>
  router.createUrlTree([
    isBoUser ? AppConfig.routes.dashboard : AppConfig.routes.selectAccountMembership,
  ]);
